import AudioPreview from 'components/UI/AudioPreview';
import { Button, Form } from 'react-bootstrap';
import { IoClose, IoPause, IoPlay } from 'react-icons/io5';
import { TbPencil, TbPencilCheck, TbPencilX } from 'react-icons/tb';
import { formatAudioFileSize, getAudioDisplayName } from '../../utils/audioFiles.utils';

const AudioActionRow = ({
  audio,
  index = 0,
  compact = false,
  checked = false,
  onToggle,
  onEdit,
  onDelete,
  toEdit,
  editName,
  onEditNameChange,
  onResolveEdit,
  onCancelEdit,
  canEditDelete,
  updateAudioList,
}) => {
  const rowBackground = index % 2 ? 'bg-primary-shadow' : 'bg-primary';
  const audioName = getAudioDisplayName(audio);

  return (
    <div
      className={`${
        compact
          ? 'd-flex align-items-center gap-2 px-3 py-2'
          : 'd-flex align-items-center gap-2 px-3 py-1'
      } ${rowBackground} border-top border-light border-opacity-10 min-width-0 overflow-hidden`}
    >
      <div className="d-flex align-items-center gap-2 min-width-0 flex-grow-1">
        {canEditDelete && !audio.readonly && (
          <div className="flex-shrink-0">
            <Form.Check
              type="checkbox"
              className="mb-0"
              checked={checked}
              onChange={onToggle}
              aria-label={audioName}
            />
          </div>
        )}

        <div className="flex-grow-1 min-width-0">
          {toEdit !== audio.id ? (
            <div
              className={`d-flex min-width-0 ${
                compact ? 'flex-column align-items-start gap-1' : 'align-items-center gap-2'
              }`}
            >
              <span className="text-truncate d-block min-width-0">{audioName}</span>
              {!!audio.readonly && (
                <span className="badge bg-secondary flex-shrink-0" style={{ fontSize: '0.65rem' }}>
                  Read-only
                </span>
              )}
              {audio?.size != null && (
                <span className="text-muted small flex-shrink-0">
                  ({formatAudioFileSize(audio.size, 1048576)})
                </span>
              )}
            </div>
          ) : (
            <Form.Control
              size="sm"
              className="bg-primary"
              type="text"
              value={editName}
              onChange={(e) => onEditNameChange(e.target.value)}
            />
          )}
        </div>
      </div>

      <div className={`d-flex align-items-center flex-shrink-0 gap-1 ${compact ? 'ms-auto' : ''}`}>
        <div className="flex-shrink-0">
          <AudioPreview
            tone={audio}
            playButtonOverride={<IoPlay size={18} />}
            pauseButtonOverride={<IoPause size={18} />}
            buttonClassName="btn btn-primary d-inline-flex align-items-center justify-content-center p-0"
            buttonStyle={{ width: 36, height: 36 }}
            update={updateAudioList}
          />
        </div>

        {canEditDelete && !audio.readonly && (
          <>
            {toEdit !== audio.id && (
              <Button
                size="sm"
                variant="outline-secondary"
                title="Rename"
                onClick={() => onEdit(audio)}
              >
                <TbPencil size={16} />
              </Button>
            )}
            {toEdit === audio.id && (
              <>
                <Button size="sm" variant="success" title="Save name" onClick={onResolveEdit}>
                  <TbPencilCheck size={16} />
                </Button>
                <Button size="sm" variant="outline-secondary" title="Cancel" onClick={onCancelEdit}>
                  <TbPencilX size={16} />
                </Button>
              </>
            )}
            <Button
              size="sm"
              variant="outline-danger"
              title="Delete"
              onClick={() => onDelete(audio.id)}
            >
              <IoClose size={16} />
            </Button>
          </>
        )}
      </div>
    </div>
  );
};

export default AudioActionRow;
